<div class="calendar-container">
  <!-- Header -->
  <div class="calendar-header">
    <div class="header-left">
      <h1 class="page-title">Calendario de Eventos</h1>
      <p class="page-subtitle">Próximas clases en vivo y webinars</p>
    </div>
    <button class="today-btn" (click)="goToToday()">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" stroke-width="2"/>
        <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" stroke-width="2"/>
      </svg>
      Hoy
    </button>
  </div>

  <div class="calendar-content">
    <!-- Loading State -->
    @if (isLoading()) {
      <div class="loading-overlay">
        <div class="spinner-large"></div>
        <p class="loading-text">Cargando eventos...</p>
      </div>
    }

    <!-- Calendar Main -->
    <div class="calendar-main" [class.loading]="isLoading()">
      <!-- Calendar Controls -->
      <div class="calendar-controls">
        <button class="control-btn" (click)="previousMonth()">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        
        <h2 class="current-month">{{getCurrentMonthYear()}}</h2>
        
        <button class="control-btn" (click)="nextMonth()">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>

      <!-- Calendar Grid -->
      <div class="calendar-grid">
        <!-- Week Days Header -->
        <div class="weekdays">
          <div class="weekday" *ngFor="let day of weekDays">{{day}}</div>
        </div>

        <!-- Calendar Days -->
        <div class="days-grid">
          <div 
            *ngFor="let day of calendarDays()"
            class="calendar-day"
            [class.other-month]="!day.isCurrentMonth"
            [class.today]="day.isToday"
            [class.selected]="isSameDay(selectedDate(), day.date)"
            [class.has-events]="day.events.length > 0"
            (click)="selectDate(day)">
            
            <div class="day-number">{{day.date.getDate()}}</div>
            
            <div class="day-events" *ngIf="day.events.length > 0">
              <div 
                *ngFor="let event of day.events.slice(0, 2)"
                class="event-dot"
                [style.background]="event.color"
                [title]="event.title">
              </div>
              <span class="more-events" *ngIf="day.events.length > 2">
                +{{day.events.length - 2}}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Selected Date Events -->
      <div class="selected-date-panel" *ngIf="selectedDate() && getSelectedDateEvents().length > 0">
        <div class="panel-header">
          <h3 class="panel-title">{{formatDate(selectedDate()!)}}</h3>
          <button class="close-btn" (click)="selectedDate.set(null)">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
        
        <div class="panel-events">
          <div 
            *ngFor="let event of getSelectedDateEvents()"
            class="panel-event"
            (click)="goToLiveClass(event.id)">
            <div class="event-color" [style.background]="event.color"></div>
            <div class="event-details">
              <h4 class="event-title">{{event.title}}</h4>
              <div class="event-meta">
                <span class="event-time">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                    <path d="M12 6V12L16 14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                  {{getEventTime(event)}} • {{event.duration}}
                </span>
                <span class="event-instructor">{{event.instructor}}</span>
              </div>
            </div>
            <svg class="event-arrow" width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </div>
        </div>
      </div>
    </div>

    <!-- Upcoming Events Sidebar -->
    <aside class="events-sidebar">
      <div class="sidebar-header">
        <h3 class="sidebar-title">Próximos Eventos</h3>
      </div>

      <div class="upcoming-events">
        <div 
          *ngFor="let event of getUpcomingEvents()"
          class="event-card"
          (click)="goToLiveClass(event.id)">
          
          <div class="event-image">
            <img [src]="event.thumbnail" [alt]="event.title">
            <div class="event-badge" [style.background]="event.color">
              {{event.category}}
            </div>
          </div>

          <div class="event-content">
            <div class="event-date">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" stroke-width="2"/>
                <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" stroke-width="2"/>
              </svg>
              {{event.date.toLocaleDateString('es-ES', { month: 'short', day: 'numeric' })}}
            </div>

            <h4 class="event-card-title">{{event.title}}</h4>
            
            <div class="event-info">
              <div class="info-row">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                  <path d="M12 6V12L16 14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                </svg>
                <span>{{getEventTime(event)}} • {{event.duration}}</span>
              </div>
              
              <div class="info-row">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2"/>
                  <path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  <path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                </svg>
                <span>{{event.attendees}}/{{event.maxAttendees}}</span>
              </div>
              
              <div class="info-row instructor">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2"/>
                </svg>
                <span>{{event.instructor}}</span>
              </div>
            </div>

            <div class="event-attendance">
              <div class="attendance-bar">
                <div class="attendance-fill" [style.width.%]="getAttendancePercentage(event)"></div>
              </div>
              <span class="attendance-text" [class.full]="isEventFull(event)">
                {{isEventFull(event) ? 'Completo' : getAttendancePercentage(event) + '% ocupado'}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </aside>
  </div>
</div>

